class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
    this.onSearchResize = this.positionSearchModal.bind(this);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  isHeaderSearch() {
    return this.classList.contains('header__search');
  }

  positionSearchModal() {
    if (!this.isHeaderSearch()) return;

    const modal = this.querySelector('.search-modal');
    const headerWrapper = this.closest('.header-wrapper');
    if (!modal || !headerWrapper) return;

    const rect = headerWrapper.getBoundingClientRect();
    modal.style.setProperty('position', 'fixed', 'important');
    modal.style.setProperty('top', `${rect.top}px`, 'important');
    modal.style.setProperty('left', `${rect.left}px`, 'important');
    modal.style.setProperty('right', 'auto', 'important');
    modal.style.setProperty('bottom', 'auto', 'important');
    modal.style.setProperty('width', `${rect.width}px`, 'important');
    modal.style.setProperty('height', `${rect.height}px`, 'important');
    modal.style.setProperty('max-width', 'none', 'important');
  }

  clearSearchModalPosition() {
    if (!this.isHeaderSearch()) return;

    const modal = this.querySelector('.search-modal');
    if (!modal) return;

    ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'max-width'].forEach((property) => {
      modal.style.removeProperty(property);
    });
    window.removeEventListener('resize', this.onSearchResize);
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    this.positionSearchModal();
    if (this.isHeaderSearch()) window.addEventListener('resize', this.onSearchResize);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    this.clearSearchModalPosition();
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
